/** Display-only copy discovered by the complete Pipeline and movement audit. */
export const operationsAuditArabicTranslations: Record<string, string> = {
  'Answer': 'تم التواصل',
  'Demo': 'ديمو',
  'Active leads': 'العملاء النشطين',
  'Search: {0}': 'البحث: {0}',
  'Month: {0}': 'الشهر: {0}',
  'Added: {0} – {1}': 'تاريخ الإضافة: {0} – {1}',
  'Course: {0}': 'الكورس: {0}',
  'Tag: {0}': 'التصنيف: {0}',
  'Employee: {0}': 'الموظف: {0}',
  'Campaign: {0}': 'الحملة: {0}',
  'Stage: {0}': 'المرحلة: {0}',
  'Sort: {0}': 'الترتيب: {0}',
  'A lead with this phone number already exists.': 'في عميل محتمل بنفس رقم التليفون موجود بالفعل.',
  'Test data': 'بيانات تجريبية',
  'Unable to send WorkMail': 'مش قادرين نبعت رسالة WorkMail',
  'Unable to save WorkMail draft': 'مش قادرين نحفظ مسودة WorkMail',
  'No answer, will retry.': 'مفيش رد، هحاول تاني.',
  'Interested, asked for details.': 'مهتم وطلب تفاصيل.',
  'Requested price.': 'طلب معرفة السعر.',
  'Asked to call later.': 'طلب الاتصال في وقت تاني.',
  'Wants to discuss with family/team.': 'عايز يناقش الموضوع مع أهله أو فريقه.',
  'Not interested now.': 'مش مهتم دلوقتي.',
  'Update stage': 'تعديل المرحلة',
  'Quick Action': 'إجراء سريع',
  'Keep current stage': 'الإبقاء على المرحلة الحالية',
  'Stage classification': 'تصنيف المرحلة',
  '{0} classification': 'تصنيف {0}',
  '{0} is required': '{0} مطلوب',
  '{0} is required.': '{0} مطلوب.',
  'Choose action': 'اختار الإجراء',
  'Write note first': 'اكتب ملاحظة الأول',
  'Select follow-up date': 'اختار موعد المتابعة',
  'Choose outcome first': 'اختار النتيجة الأول',
  'Select meeting date': 'اختار موعد المقابلة',
  'Add a short note or reason': 'ضيف ملاحظة قصيرة أو سبب',
  'Unable to save action': 'مش قادرين نحفظ الإجراء',
  'No response yet': 'مفيش رد لحد دلوقتي',
  'Log the touch and schedule the next attempt so the lead stays visible.': 'سجّل التواصل وحدد موعد المحاولة الجاية عشان تتابع الليد.',
  'Close as lost': 'إغلاق كليد مفقود',
  'Use only when the phone is invalid or the contact cannot be reached.': 'استخدم ده بس لو الرقم غلط أو مش ممكن تتواصل مع العميل.',
  'Move into nurture': 'الانتقال للمتابعة',
  'Lead showed intent. Add the next step and keep accountability clear.': 'الليد أظهر اهتمام. حدد الخطوة الجاية عشان المتابعة تبقى واضحة.',
  'Keep stage, schedule action': 'ثبّت المرحلة وحدد موعد الإجراء',
  'Use this when the next step is known but the stage should not move.': 'استخدم ده لما الخطوة الجاية معروفة والمرحلة محتاجة تفضل زي ما هي.',
  'Offer sent': 'تم إرسال العرض',
  'Record proposal context and set a follow-up before it goes cold.': 'سجّل تفاصيل العرض وحدد متابعة قبل ما اهتمام العميل يقل.',
  'Consultation booked': 'تم حجز الاستشارة',
  'Save the meeting time so reception and sales can see the commitment.': 'احفظ موعد المقابلة عشان المبيعات والاستقبال يقدروا يتابعوه.',
  'Negotiating terms': 'التفاوض على الشروط',
  'Capture the objection or requested change with a follow-up.': 'سجّل الاعتراض أو التعديل المطلوب وحدد متابعة.',
  'Registration flow': 'خطوات التسجيل',
  'Use registration/invoice workflow': 'استخدم خطوات التسجيل والفاتورة',
  'Registration is owned by the official student and invoice path.': 'التسجيل بيتم من خطوات ملف الطالب والفاتورة الرسمية.',
  'Close with reason': 'الإغلاق مع تسجيل السبب',
  'Close the loop with a clean reason for reporting and cleanup.': 'سجّل سبب واضح للإغلاق عشان التقارير والمتابعة.',
  'Lost reason': 'سبب فقدان الليد',
  'Proposal notes': 'ملاحظات العرض',
  'Objection / requested change': 'الاعتراض أو التعديل المطلوب',
  'Interest note': 'ملاحظة الاهتمام',
  'Meeting time': 'موعد المقابلة',
  'Choose an outcome first.': 'اختار النتيجة الأول.',
  'Save outcome': 'حفظ النتيجة',
  'Use the registration/invoice workflow for this outcome.': 'استخدم خطوات التسجيل والفاتورة للنتيجة دي.',
  'Workflow locked': 'الإجراء مقفول',
  'Select meeting time.': 'اختار موعد المقابلة.',
  'Select next follow-up time.': 'اختار موعد المتابعة الجاية.',
  'Close lead': 'إغلاق الليد',
  'Unable to load your saved contact. Retry before editing.': 'مش قادرين نحمّل التواصل المحفوظ. جرّب تاني قبل التعديل.',
  'Draft saved · contact result not submitted': 'المسودة اتحفظت · نتيجة التواصل لسه متبعتتش',
  'Draft could not be saved. Keep this page open and save the result.': 'المسودة متحفظتش. سيب الصفحة مفتوحة واحفظ النتيجة.',
  'Lost Comment': 'تعليق فقدان الليد',
  'Comment for this contact attempt': 'تعليق محاولة التواصل دي',
  'required': 'مطلوب',
  'optional': 'اختياري',
  'Complete the required Demo Details before saving.': 'كمّل تفاصيل الديمو المطلوبة قبل الحفظ.',
  'Unable to save contact attempt': 'مش قادرين نحفظ محاولة التواصل',
  'Attempt saved successfully.': 'محاولة التواصل اتحفظت بنجاح.',
  'Unable to discard this draft. Try again.': 'مش قادرين نحذف المسودة دي. جرّب تاني.',
  'Attended': 'حضر',
  'No Show': 'محضرش',
  'Viewed': 'شاهد التسجيل',
  'Not Viewed Yet': 'لسه مشافش التسجيل',
  'Reschedule Demo': 'تغيير موعد الديمو',
  'Replacement': 'البديل',
  'Superseded': 'تم استبداله',
  '{0}Demo Type': '{0}نوع الديمو',
  '{0}Demo Date': '{0}تاريخ الديمو',
  '{0}Demo Time': '{0}وقت الديمو',
  '{0}Course / Group': '{0}الكورس أو المجموعة',
  '{0}Recorded Lecture': '{0}المحاضرة المسجلة',
  '{0}Recorded Lecture Link': '{0}رابط المحاضرة المسجلة',
  '{0}Demo Reminder Date': '{0}تاريخ تذكير الديمو',
  '{0}Demo Reminder Time': '{0}وقت تذكير الديمو',
  '{0}Next Follow-Up Date': '{0}تاريخ المتابعة الجاية',
  '{0}Next Follow-Up Time': '{0}وقت المتابعة الجاية',
  '{0}Demo Next Action Date': '{0}تاريخ متابعة الديمو',
  '{0}Demo Next Action Time': '{0}وقت متابعة الديمو',
  'Contact attempt': 'محاولة تواصل',
  'Stage changed': 'تم تغيير المرحلة',
  'Lead assigned': 'تم تعيين الليد',
  'Comment added': 'تم إضافة تعليق',
  'Follow-up scheduled': 'تم تحديد موعد متابعة',
  'Registration link opened': 'تم فتح رابط التسجيل',
  'Registration link created': 'تم إنشاء رابط التسجيل',
  'Call contact': 'تواصل بمكالمة',
  'WhatsApp contact': 'تواصل على واتساب',
  'Email contact': 'تواصل بالإيميل',
  'Date unavailable': 'التاريخ مش متاح',
  'Sales team': 'فريق المبيعات',
  'Lead activity': 'نشاط الليد',
  'Next contact: {0} · {1}': 'التواصل الجاي: {0} · {1}',
  'Transferred from {0} to {1}': 'تم النقل من {0} إلى {1}',
  'Assigned to {0}': 'تم التعيين لـ {0}',
  'Attempt #{0}': 'محاولة رقم {0}',
  'Assignment target not recorded': 'الموظف المستلم مش مسجّل',
  'Returned to original owner': 'رجع للموظف الأصلي',
  'previous owner': 'الموظف السابق',
  'new owner': 'الموظف الجديد',
  'Due': 'مستحق',
  'Unable to load conversion details.': 'مش قادرين نحمّل تفاصيل التسجيل والدفع.',
  'Unable to create a registration link.': 'مش قادرين ننشئ رابط التسجيل.',
  'Registration link is ready to share.': 'رابط التسجيل جاهز للمشاركة.',
  'Registration link copied.': 'تم نسخ رابط التسجيل.',
  'Unable to copy the payment link.': 'مش قادرين ننسخ رابط الدفع.',
  'Registration link ready to share.': 'رابط التسجيل جاهز للمشاركة.',
  'Upload a JPG or PNG file up to 5 MB.': 'ارفع صورة JPG أو PNG بحجم لحد 5 ميجابايت.',
  'Unable to upload receipt photo.': 'مش قادرين نرفع صورة الإيصال.',
  'Receipt photo uploaded.': 'تم رفع صورة الإيصال.',
  'Complete the required fields and upload a receipt photo.': 'كمّل البيانات المطلوبة وارفع صورة الإيصال.',
  'Paid Amount cannot exceed the Remaining Balance.': 'المبلغ المدفوع مينفعش يكون أكبر من المبلغ المتبقي.',
  'Receipt could not be created. Please try again.': 'الإيصال متعملش. جرّب تاني.',
  'Receipt created and sent for Marketing review.': 'الإيصال اتعمل واتبعت لمراجعة التسويق.',
  'Course not provided': 'الكورس مش مسجّل',
  'Failed to load registration links': 'مش قادرين نحمّل روابط التسجيل',
  'Failed to update referral': 'مش قادرين نحدّث الإحالة',
  'Referral linked successfully': 'تم ربط الإحالة بنجاح',
  'Failed to link referral': 'مش قادرين نربط الإحالة',
  'Failed to generate registration link': 'مش قادرين ننشئ رابط التسجيل',
  'Registration link generated!': 'تم إنشاء رابط التسجيل!',
  'Failed to generate link': 'مش قادرين ننشئ الرابط',
  'Message and link copied!': 'تم نسخ الرسالة مع الرابط!',
  'Failed to copy': 'النسخ متعملش',
  'Use registration flow': 'استخدم خطوات التسجيل',
  'Create first receipt': 'إنشاء أول إيصال',
  'Use payment workflow': 'استخدم خطوات الدفع',
  'Review invoice path': 'مراجعة خطوات الفاتورة',
  'Use outcome modal': 'استخدم نافذة النتيجة',
  'Open lead workflow': 'فتح خطوات الليد',
  '{0} is locked': 'مرحلة {0} مقفولة',
  '{0} is part of the closed/system area. Reopen or change it through the lead workflow so history stays auditable.': 'مرحلة {0} من المراحل المقفولة أو اللي بيتحكم فيها النظام. افتحها أو غيّرها من خطوات الليد عشان التغيير يتسجّل في السجل.',
  'Closed/system stages should not move by drag.': 'المراحل المقفولة أو اللي بيتحكم فيها النظام مينفعش تتنقل بالسحب.',
  'Use a workflow action so the reason is written to history.': 'استخدم الإجراء المخصص عشان السبب يتسجّل في السجل.',
  'Open drawer actions': 'فتح إجراءات ملف الليد',
  'Call, WhatsApp, or email first.': 'تواصل بمكالمة أو واتساب أو إيميل الأول.',
  'Record the result so the next stage has evidence.': 'سجّل النتيجة عشان المرحلة الجاية يكون ليها دليل.',
  'New Lead should not be used as a manual fallback bucket.': 'مرحلة الليد الجديد مينفعش تُستخدم كمرحلة بديلة يدويًا.',
  'Use the workflow built for this stage.': 'استخدم الخطوات المخصصة للمرحلة دي.',
  'The system will keep reports and cross-system links consistent.': 'النظام بيحافظ على توافق التقارير والروابط بين الأقسام.',
  '{0} needs a stage tag before the board can move {1}.': 'مرحلة {0} محتاجة تصنيف قبل نقل {1} من اللوحة.',
  'Pick the reason/status tag inside the lead workflow.': 'اختار تصنيف السبب أو الحالة من خطوات الليد.',
  'Then the board can reflect the evidence cleanly.': 'بعدها اللوحة هتعرض الحالة بناءً على البيانات المسجّلة.',
  'Confirm move': 'تأكيد النقل',
  'Move {0} from {1} to {2}.': 'نقل {0} من {1} إلى {2}.',
  'Stage tag: {0}': 'تصنيف المرحلة: {0}',
  'No stage tag required for this move.': 'النقلة دي مش محتاجة تصنيف للمرحلة.',
  'Reporting and Work Now queues update after confirmation.': 'التقارير وقوائم العمل بتتحدث بعد التأكيد.',
  'Next action remains the source of follow-up accountability.': 'الإجراء الجاي هو المرجع لتنظيم المتابعة.',
  'Submit for Approval': 'إرسال للموافقة',
  'Create a lead card in New.': 'إنشاء ليد في مرحلة جديد.',
  'Submit a lead addition request for manager approval.': 'إرسال طلب إضافة ليد لموافقة المدير.',
  'New Phone Number': 'رقم تليفون جديد',
  'This phone number already belongs to an existing customer.': 'رقم التليفون ده مسجّل لعميل موجود بالفعل.',
  'There is already a pending request for this phone number.': 'فيه طلب لسه مستني الموافقة للرقم ده.',
  'Unable to save note': 'مش قادرين نحفظ الملاحظة',
  'Unable to save follow-up': 'مش قادرين نحفظ المتابعة',
  'Unable to log interaction': 'مش قادرين نسجّل التواصل',
  'Call outcome saved': 'تم حفظ نتيجة المكالمة',
  'Interaction saved': 'تم حفظ التواصل',
  'Use the registration/invoice workflow for registration outcomes': 'استخدم خطوات التسجيل والفاتورة لنتائج التسجيل',
  'Invalid outcome': 'النتيجة مش صحيحة',
  'Unable to update outcome': 'مش قادرين نحدّث النتيجة',
  'Unable to clear follow-up': 'مش قادرين نمسح المتابعة',
  'Unable to complete WhatsApp follow-up': 'مش قادرين نكمّل متابعة واتساب',
  'Your employee identity is missing. Please refresh and sign in again.': 'بيانات حساب الموظف مش موجودة. حدّث الصفحة وسجّل دخول تاني.',
  'This lead is unassigned. Assign it before messaging.': 'الليد ده مش متعيّن لموظف. عيّنه الأول قبل المراسلة.',
  'Agents can only message leads assigned to them.': 'الموظف يقدر يراسل الليدز المتعيّنة ليه بس.',
  'Unable to save WhatsApp outcome': 'مش قادرين نحفظ نتيجة واتساب',
  'Follow-up created from WhatsApp outcome': 'تم إنشاء متابعة من نتيجة واتساب',
  'Unable to request transfer': 'مش قادرين نرسل طلب النقل',
  'Unable to load activities': 'مش قادرين نحمّل الأنشطة',
  'Registration handoff': 'متابعة التسجيل',
  'Student handoff': 'متابعة ملف الطالب',
  'Closure evidence': 'دليل الإغلاق',
  'Confirm the handoff evidence and keep the sales lane clean.': 'أكد دليل التسجيل عشان مسار المبيعات يفضل واضح.',
  'Review the close reason before reopening or retargeting.': 'راجع سبب الإغلاق قبل إعادة الفتح أو تغيير الاستهداف.',
  'Owner #{0}': 'الموظف رقم {0}',
  'Focus {0} stage': 'عرض مرحلة {0}',
  'Clear all selections': 'مسح كل الاختيارات',
  'Search options': 'البحث في الاختيارات',
  'No matches': 'مفيش نتائج مطابقة',
  'No options': 'مفيش اختيارات',
  'awaiting customer payment': 'في انتظار دفع العميل',
  'registration completed': 'التسجيل مكتمل',
  'marketing review': 'مراجعة التسويق',
  'reception review': 'مراجعة الاستقبال',
  'approved collection': 'التحصيل معتمد',
  'registered': 'مسجّل',
  'awaiting payment': 'في انتظار الدفع',
  'payment pending': 'في انتظار اعتماد الدفع',
  'pending review': 'في انتظار المراجعة',
};

export const operationsAuditEnglishTranslations: Record<string, string> = {
  'تم نسخ الرسالة مع الرابط!': 'Message and link copied!',
};
